import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { HttpClient } from './http-client';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { dateToUnixTime } from "../utils/DateHelper";
import { DEFAULT_PAGE_SIZE } from '.';
import {ClienteViewModel, ResponseGeneric} from '@utils/ViewModels';

export const SEARCH_TYPE_COLABORADOR = 'SEARCH_TYPE_COLABORADOR';
export const SEARCH_TYPE_CUENTA = 'SEARCH_TYPE_CUENTA';
export const SEARCH_TYPE_MOTOR = 'SEARCH_TYPE_MOTOR';
export const SEARCH_TYPE_CONSIGNA = 'SEARCH_TYPE_CONSIGNA';
export const SEARCH_TYPE_LABEL = 'SEARCH_TYPE_LABEL';
export const SEARCH_TYPE_ACOPIO = 'SEARCH_TYPE_ACOPIO';
export const SEARCH_TYPE_CATEGORIA = 'SEARCH_TYPE_CATEGORIA';
export const SEARCH_TYPE_CONTACTO = 'SEARCH_TYPE_CONTACTO';
export const SEARCH_TYPE_ACOPIO_NEW_NEGOCIO = 'SEARCH_TYPE_ACOPIO_NEW_NEGOCIO';

@Injectable()
export class SearchService {

    private cachedLabels;

    constructor(private httpClient: HttpClient,
                private router: Router) {

    }

    searchLabel(term: string): Observable<any>{
        if (!this.cachedLabels){
          return this.httpClient.get(`/api/etiquetas/my-network`)
            .map((response: Response) => {
              if (response){
                this.cachedLabels = response.json().ResponseData;
                return response.json().ResponseData.filter(v => v.Etiqueta.toLowerCase().includes(term.toLowerCase()));
              }
            });
        } else {
          return Observable.from([this.cachedLabels.filter(v => v.Etiqueta.toLowerCase().includes(term.toLowerCase()))]);
        }
    }

    searchCategoria(term: string): Observable<any>{
        return this.httpClient.get(`/api/categoria/`)
        .map((response: Response) => {
          if (response){
            return response.json().ResponseData.filter(v => v.Categoria.toLowerCase().includes(term.toLowerCase()));
          }
      });
    }

    search(term: string, type, page = 0, payloadData?): Observable<any> {
        let path: string;
        let request = {
          UserId: localStorage.getItem('userId'),
          PageSize: DEFAULT_PAGE_SIZE,
          PageNumber: page,
          Name: term
        };

        switch (type) {
          case SEARCH_TYPE_COLABORADOR:
            path = '/api/search/colaborador/';
            break;
          case SEARCH_TYPE_CUENTA:
            path = '/api/search/cuenta/';
            break;
          case SEARCH_TYPE_CONSIGNA:
            path = '/api/search/consigna/';

            if (payloadData.To instanceof Date){
              payloadData.To = dateToUnixTime(payloadData.To);
            }

            if (payloadData.From instanceof Date){
              payloadData.From = dateToUnixTime(payloadData.From);
            }

            break;
        }


        if (payloadData){
          request = {...request, ...payloadData};
        }

        return this.httpClient.post(path, request)
            .map((response: Response) => {
              if (response){
                return response.json().ResponseData;
              }
            });
      }

      searchAutocomplete(term: string, type, page: number = 0, cuentaId: number = 0): Observable<any> {

        let baseUrl: string;

        switch (type) {
          case SEARCH_TYPE_COLABORADOR:
            baseUrl = '/api/user/search';
            break;
          case SEARCH_TYPE_CUENTA:
            baseUrl = '/api/cuentas/search';
            break;
          case SEARCH_TYPE_MOTOR:
            baseUrl = '/api/motor/';
            break;
          case SEARCH_TYPE_LABEL:
            return this.searchLabel(term);
          case SEARCH_TYPE_ACOPIO:
            baseUrl = '/api/acopios/acopios-by-user-rol/';
            break;
          case SEARCH_TYPE_ACOPIO_NEW_NEGOCIO:
            baseUrl = '/api/acopios/acopios-by-user-rol-and-client/';
            break;
          case SEARCH_TYPE_CATEGORIA:
            baseUrl = '/api/roles/categorias/';
            break;
          case SEARCH_TYPE_CONTACTO:
            baseUrl = '/api/contactos/';
            break;
          default:
            baseUrl = '/api/user/search/';
            break;
        }

        let fullUrl = baseUrl + term;

        if (type === SEARCH_TYPE_CUENTA || type === SEARCH_TYPE_COLABORADOR) {
          const payload = {Busqueda: term};
          if (type === SEARCH_TYPE_CUENTA) {
            payload['PageSize'] = DEFAULT_PAGE_SIZE;
            payload['PageNumber'] = page;
            payload['Habilitada'] = true;
            payload['NuevoNegocio'] = true;
          }
          return this.httpClient.post(baseUrl, payload)
            .map((response: Response) => {
              if (response) { return response.json().ResponseData; }
            });

        } else if (type === SEARCH_TYPE_CONTACTO) {
          fullUrl = `${baseUrl}${DEFAULT_PAGE_SIZE}/${page}/${term}`;
        }else if (type === SEARCH_TYPE_ACOPIO_NEW_NEGOCIO) {
          fullUrl = `${baseUrl}${term}/${cuentaId}`;
        }

        return this.httpClient.get(fullUrl)
           .map((response: Response) => {
             if (response){
               return response.json().ResponseData;
             }
           });
      }
  searchCuentaAutocomplete(searchTerm: string): Observable<ClienteViewModel[]> {
    const payload: SearchFilterViewModel = {
      Busqueda: searchTerm, Habilitada: true, NuevoNegocio: true, PageNumber: 0, PageSize: 30
    }
    return this.httpClient.post('/api/cuentas/search', payload)
      .map((response: Response) => {
        const res = response.json() as ResponseGeneric<ClienteViewModel[]>;
        return res.ResponseData;
      });
  }
}

interface SearchFilterViewModel {
  Busqueda: string;
  PageSize: number;
  PageNumber: number;
  Habilitada: boolean;
  NuevoNegocio: boolean;
  Activo?: boolean;
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/search-service.ts